export const status = [
  { id: 'open', name: 'OPEN' },
  { id: 'closed', name: 'CLOSED' },
];
